export const PLATFORM_ROLE = Object.freeze({
  NONE: "None",
  PLATFORM_ADMIN: "PlatformAdmin",
});